import { gql } from 'apollo-boost';

export const MY_EXPORT_STATUS = gql`
    query {
        myExportStatus {
            id
            status
            scope
            options {
                exportType
                includeNotes
                includeFiles
                includeImages
                includeVideos
                includeAudio
                includeLinks
            }
            resultUrl
            expiresAt
            error
            declinedAt
            declinedReason
            cancelledAt
            createdAt
            completedAt
        }
    }
`;
